import { Routes } from '@angular/router';

import { CodemirrorDemoComponent } from './codemirror-demo.component';

export const codemirrorRoutes: Routes = [
  { path: 'codemirror', component: CodemirrorDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/codemirror/codemirror.routes.ts